<template>
  <el-container id="root_container" style="padding: 0px;margin: 0px; overflow: hidden;">

    <el-header class="headerManu"><nav-header active-index="pesc"></nav-header></el-header>

    <el-main id="router_view">
      <el-row>
        <!--左侧菜单-->
        <el-col  id="menu_container" :span="menuSpan">
          <ih-signal-vertical-tabs :activeTab="activeTab" :mTabs="mTabs" @tabChanged="menuClicked" v-show="true"></ih-signal-vertical-tabs>
        </el-col>

        <!--地图容器-->
        <el-col :span="mapSpan" style="position: relative">
          <!-- Map container-->
          <div id="map" style="width: auto; z-index: 1"></div>

          <div  id="mapResizeButton"
                style="cursor: pointer;
                background-color: rgb(67,133,185); width: 27px; height: 98px;padding: 2px;border-radius: 3px; border: 3px solid rgb(135,206,235)">
            <img :src="zoomIn" style="width: 100%; color: white;margin-left: -1px; width: 30px;height: 30px;" title="Operation manual"  @click="openOperationMenu"/>
            <img :src="zoomOut" style="width: 100%; color: white;margin-top: 5px; margin-bottom: 5px; width: 22px;height: 22px;" @click="openDescriptionDlg"/>
            <img :src="menuResizeIcon" style="width: 100%; color: white;width: 25px;height: 25px;" @click="mapResize"/>
          </div>


          <!--图例-->
          <map-lengend
            :title="legendTitle"
            ref="ref_mapLegend"
            @colorsChanged="colorsChanged"
            :legends="selectedMapLegendsStyle"
            class="legend" id="IDLegend" @layoutupdate="legend_layoutupdate" style="display: none;"></map-lengend>

          <!--Radio Group-->
          <div  class="radio_group">

            <el-radio-group v-model="radioG_cc_prcptot" class="item_one" @change="radioGroup_change" v-if="radioData.length>0" style="margin-right: 10px;">
              <el-radio :label="item.radio_code"  v-for="(item ,index) in radioData"  :key="index">{{item.radio_title}}</el-radio>
            </el-radio-group>

            <el-cascader class="GS_SHIDUAN" placeholder="Switch" v-model="selected_cascader" :options="cascader_options" @change="radioGroup_change" v-if="cascader_options.length>0"></el-cascader>

            <el-radio-group v-model="radioG_cc_prcptot_type" class="item_more" @change="radioGroup_change" v-if="radioGroupVisible_cv">
              <el-radio label="value">Value</el-radio>
              <el-radio label="change">Change</el-radio>
            </el-radio-group>


            <el-radio-group v-model="radioG_cc_prcptot_mm" class="item_more" @change="radioGroup_change"   v-if="radioGroupVisible_es"  style="margin-left: 10px;">
              <el-radio label="mme">MME</el-radio>
              <el-radio label="mms">MMS</el-radio>
            </el-radio-group>

          </div>

          <!--MapLengends-->
          <!--          <div class="css_cascader" style="background-color: transparent;">-->
          <!--            <el-cascader placeholder="Switch" v-model="selected_cascader" :options="cascader_options" @change="radioGroup_change" v-if="cascader_options.length>0"></el-cascader>-->
          <!--          </div>-->

          <!--map layer source name  | toolabs-->
          <div class="css_map_footer"  v-if="selectedRasterMapSrouce!=undefined?true:false">
            <div class="bg"></div>
            <div class="context">
              {{ selectedRasterMapSrouce.toUpperCase()}}
              <a id="image-download" download="map.png"></a>
              <!--map export png-->
              <img :src="file_download"  style="float: left;margin-left: 10px; margin-top: 5px;width: 30px;height: 30px;" @click="mapExport"/>
              <img :src="file_detail"  style="float: left;margin-left: 15px; margin-top: 6px;width: 26px;height: 26px;" @click="mapDeitalView"/>

              <!--map legend controller-->
              <div style="float:right; width: 25px;height: 25px;margin-right: 5px;" @click="legend_layoutupdate_show">
                <img :src="legendModel==0?icon_zhankai_w:icon_shousuo_w" style="width: 100%; margin-top: 7px;" id="IDLegendButton">
              </div>
            </div>

          </div>

          <!-- overlay-->
          <div id="popup" class="ol-popup">
            <el-row style="background-color: transparent; line-height: 30px; height: 30px; width: 120px;">
              <el-col :span=20 style="text-align: left;"><div style="padding-right: 20px;">{{
                  selectedRasterMapData=="NO DATA"?"NO DATA":parseFloat(selectedRasterMapData).toFixed(2)
                }}</div></el-col>
              <el-col :span=4 style="text-align: right;">
                <a href="#" id="popup-closer" class="ol-popup-closer" style="font-size: 17px;"></a>
              </el-col>
            </el-row>
          </div>




        </el-col>

      </el-row>
    </el-main>



    <el-dialog
      title="标题占位符"
      :visible.sync="descriptionDlgVisible"
      width="60%"
      :before-close="closeDescriptionDlg">
      <div style="text-align: left;width: 100%; height: 600px;" >
        此部分放置系统说明文档
      </div>
    </el-dialog>


  </el-container>
</template>

<script>



import  ihMap  from "@/components/map/IHMap";
import  ihVerticalTabs from "@/components/widgets/IHVerticalTabs";
import  ihSignalVerticalTabs from "@/components/widgets/IHSignalVerticalTabs";
import  mapLengend from "@/view/BSD/components/MapLengend";
let bunMenuIcon =  require( '../../assets/imgs/bunMenu.png');
let menuresizeicon_description =  require( '../../assets/icons/description.png');

import 'ol/ol.css'
import {toSize} from 'ol/size';
import {menus_env,menus_exposure,menus_risk,radioGroupData,cascaderData,radioGroupData_V2,C,Pesc_radioGroupData,Pesc_cascaderData
} from "./BSDConfig"

import {IHMapUtils} from "../../components/map/common/IHMapUtils"


import {TDM_LAYER_CVA_C,TDM_LAYER_IBO_C,TDM_LAYER_EVA_C} from "../../components/map/common/constant"
import Overlay from 'ol/Overlay';
import {Vector as VectorLayer} from "ol/layer";
import {Vector as VectorSource} from "ol/source";
import GeoJSON from "ol/format/GeoJSON";


//Init Icon Params
let menuresizeicon_min =  require( '../../assets/icons/menu_shousuo_w.png');
let menuresizeicon_max =  require( '../../assets/icons/menu_zhankai_w.png');
let icon_zhankai_w =  require( '../../assets/icons/icon_zhankai_w.png');
let icon_shousuo_w =  require( '../../assets/icons/icon_shousuo_w.png');
let bsd_logo =  require( '../../../src/assets/icons/earth.png');
let file_download =  require( '../../assets/icons/download.png');
let file_detail =  require( '../../assets/icons/查看详情.png');
let population = require('../../../static/bnuSld/population2.json');


import BSDConfigLegendTitle from "./BSDConfigLegendTitle_Population"

import AppConfig from "./AppConfig";

import {geoserver,geoserver_local,geoserver_local_tiff,geoserver_basic} from "./GEOConfig"

import NavHeader from "./components/NavHeader";
import {reverseMapLegend} from "./mapTools";
import {api_bnu_getLayerLegends ,api_bnu_docDownloadTimes} from "@/api";

let mapZoomIn =  require( '../../assets/icons/加号.png');
let mapZoomOut =  require( '../../assets/icons/减号.png');
export default {
  name: "BSDMapRISK",
  components:{ihVerticalTabs,ihSignalVerticalTabs,mapLengend,NavHeader},
  data(){
    return {
      zoomIn:mapZoomIn,
      zoomOut:mapZoomOut,

      activeIndex: 'pesc',
      menuSpan:0,
      mapSpan:24,
      menu_width:null,
      content_height:null,
      menuResizeIcon: menuresizeicon_max,
      logo: bsd_logo,
      //菜单配置
      mTabs:menus_exposure,
      //地图相关的
      map:null,
      vector_layer:null,
      geoserver:geoserver,
      geoserver_local:geoserver_local,
      geoserver_local_tiff:geoserver_local_tiff,
      geoserver_basic:geoserver_basic,

      //
      lastClicedMenuItem:"Population",//默认选中的图层
      lastClicedMenuItemGroup:"cc_precipitation",
      mapUtils:null,
      //Radio Group Data
      radioData:[],
      radioG_cc_prcptot:undefined,
      //Cascader
      default_activemenu_cc:'cc_tmean_mean',
      selected_cascader:["2000s_s0"],
      cascader_options:[],
      radioG_cc_prcptot_type:"value",
      radioG_cc_prcptot_mm:"mme",
      selectedRasterMapSrouce:undefined,
      //legend
      legendModel:0,
      icon_zhankai_w,
      icon_shousuo_w,
      file_download,
      radioGroupVisible_cv:false,
      radioGroupVisible_es:false,

      //overlay
      defaultMapOverlay:undefined,
      selectedRasterMapData:undefined,
      //
      selectedMapLegendsStyle:population["sld:ColorMapEntry"],
      loginUser:undefined,
      file_detail,
      basicOceanLayer:undefined,
      bunMenuIcon,
      menuresizeicon_description,
      descriptionDlgVisible:false,
      legendTitle:"Map Lengend",
      activeTab:0
    }
  },
  methods:{

    obj_population(){
      alert(typeof population);
      return JSON.parse(population);
    },

    //app's operation menu
    openOperationMenu(){
      //window.open(AppConfig.minio_server+"/bun/Manual%20for%20the%20use%20of%20the%20global%20typical%20disaster%20risk%20digital%20mapping%20platform.docx","_blank");
      let mzoom = this.map.getView().getZoom();
      if(mzoom>=18){
        return;
      }
      let mcenter = this.map.getView().getCenter();
      this.map.getView().setZoom(mzoom+1);
      this.map.getView().setCenter(mcenter);
    },

    //打开属性对话框
    openDescriptionDlg(){
      //this.descriptionDlgVisible = true;
      let mzoom = this.map.getView().getZoom();
      if(mzoom>1){
        let mcenter = this.map.getView().getCenter();
        this.map.getView().setZoom(mzoom-1);
        this.map.getView().setCenter(mcenter);
      }

    },

    closeDescriptionDlg(){
      this.descriptionDlgVisible = false;
    },



    colorsChanged(colorGroups){
      this.selectedMapLegendsStyle = colorGroups;
      this.dynamicLodingWMSLayer(false);
    },

    /**
     * 2020年11月19日22:57:55
     * 更新地图图例数据if (this.lastClicedMenuItem=="Population"){
     * */
    updateMapLengends(layer_code,wms_ws){
      console.log("updateMapLengends");

      let legends_params_layercode = layer_code;
      let legends_params_layercodes = legends_params_layercode.split(":");
      legends_params_layercode = legends_params_layercodes[legends_params_layercodes.length-1];
      let legends_params = {layerName:legends_params_layercode, workspace:wms_ws};
      console.log("api_bnu_getLayerLegends::prams = ",legends_params);
      api_bnu_getLayerLegends(legends_params).then(res=>{
        console.log("api_bnu_getLayerLegends:: data = ",res.data);
        let res_data = res.data;
        if(res_data==undefined||res_data.length==0){
          this.$message.error("Style DATA UNDEFINED");
        }
        else {
          let res_data_data = res_data.data;
          let selectedSLDFile = JSON.parse(res_data_data);
          console.log("obj_resData.data = ",selectedSLDFile);
          this.selectedMapLegendsStyle = reverseMapLegend(selectedSLDFile);
          if(this.legendModel==1){
            this.$refs.ref_mapLegend.updateHeight();
          }
        }
      })

    },

    updateLegendsValues(legends){
      legends.forEach(item=>{
        item.label = item.label+"X106";
      })
    },





    updateStyle(){
      this.map.getLayers().forEach(function (layer) {
        const layer_name = layer.name;
        console.log("layer_name = ",layer_name);
        if(layer_name=="Temperature_Mean:cc_tmean_ann_mean_2000s_s0_value_mme_global"){
          console.log("layer finded");
          layer.getSource().updateParams({'STYLES': "Temperature_Mean_RT_MEAN"});
        }
      })
    },
    updateStyle_2(){
      this.map.getLayers().forEach(function (layer) {
        const layer_name = layer.name;
        console.log("layer_name = ",layer_name);
        if(layer_name=="Temperature_Mean:cc_tmean_ann_mean_2000s_s0_value_mme_global"){
          console.log("layer finded");
          layer.getSource().updateParams({'STYLES': "Temperature_Mean_RT_MEAN_V2"});
        }
      })
    },


    switchFeedback(){
      let userData = this.$appStorage.getUserData();
      if(userData==undefined){
        this.$router.push({path:'/BNUMap/Login'})
      }else {
        this.$router.push({path:'/BNUMap/Feedback'})
      }
    },


    Login(){
      let userData = this.$appStorage.getUserData();
      if(userData==undefined){
        this.$router.push({path:'/BNUMap/Login'})
      }else {
        alert(JSON.stringify(userData));
      }
    },

    /**
     * login out
     * */
    LoginOut() {
      this.$confirm('Do you want to log out?', 'Prompt', {
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        //清除缓存，修改登录状态
        this.$appStorage.userLogout();
        this.loginUser = this.$appStorage.getUserMailbox();
      })
    },



    handleSelect(key, keyPath) {
      this.activeIndex = key;
      let rPath = "/BNUMap/"+key;
      this.$router.push({path:rPath})
    },

    menuClicked:function (item) {
      this.radioG_cc_prcptot_mm = "mme";
      this.foldMenuClickAcion(item);
      this.updateSelectedActiveTag(item);
    },

    //init the map container
    initMap:function () {
      this.map = this.$olMapUtils.init({map:document.getElementById("map"),center:[90.70313,17.92969],initZoom:1,geoserver:this.geoserver_local})
    },

    initLayout(){
      const screen_height = document.body.clientHeight;
      const page_header = 60;
      const content_height = screen_height -  page_header;
      document.getElementById("root_container").style.height = document.body.clientHeight+"px";
      document.getElementById("router_view").style.height = document.body.clientHeight - 60+"px";
      document.getElementById("map").style.height = document.body.clientHeight - 60+"px";
      document.getElementById("menu_container").style.height =content_height+"px";

      this.menu_width = document.getElementById("menu_container").clientWidth;
      //document.getElementById("climateMenu").style.width = this.menu_width+"px";
      //document.getElementById("ChangeRisksMenus").style.width = this.menu_width+"px";
      this.content_height = document.body.clientHeight - 60;
      //document.getElementById("mapResizeButton").style.top =this.content_height/2 -60 +"px";
      document.getElementById("mapResizeButton").style.top ="5px";
      document.getElementById("mapResizeButton").style.marginLeft ="5px";

    },

    mapResize(){
      if(this.menuSpan==3) {
        this.menuSpan = 0;
        this.mapSpan = 24;
        this.map.setSize(new toSize([document.body.clientWidth ,this.content_height]));
        this.menuResizeIcon = menuresizeicon_max;
      } else {
        this.menuSpan = 3;
        this.mapSpan = 21;
        this.map.setSize(new toSize([(document.body.clientWidth - this.menu_width),this.content_height]));
        this.menuResizeIcon = menuresizeicon_min;
      }
    },

    handleOpen(){},
    handleClose(){},

    //折叠菜单点击事件
    foldMenuClick(item)
    {
      const menuIndex = item.index;
      const menuGroup = item.$attrs.menuGroup;
      this.foldMenuClickAcion(menuIndex,menuGroup);
    },

    foldMenuClickAcion(menuIndex,menuGroup)
    {
      this.lastClicedMenuItem = menuIndex;
      this.radioG_MapTime_updateConfig();

      //更新时段
      console.log("更新时段选项：：menuIndex = ",menuIndex);
      this.cascader_options = Pesc_cascaderData[menuIndex];
      this.selected_cascader=["2000s_s0"];
      if(menuIndex=="Population"||
        menuIndex=="Gross_domestic_production"||
        menuIndex=="Global_crop_distribution"||
        menuIndex=="Global_industrial_value_added" ||
        menuIndex=="Global_road_system" ||
        menuIndex=="global_gdp_exposure_to_drought"
        // || menuIndex=="Global_population_exposure_to_high_temperature"
      ) {
        this.radioGroupVisible_cv = false;
        this.radioGroupVisible_es = false;
      } else {
        this.radioGroupVisible_cv = false;
        this.radioGroupVisible_es = true;
      }


      if(menuIndex=="Global_population_exposure_to_rainstorm"){
        this.radioGroupVisradioGroupVisible_cvible_cv = false;
        this.radioGroupVisible_es = true;
        this.radioG_cc_prcptot_type = "value";
        this.selected_cascader = ["2000s_s0"];//设置时段&情景为默认值
      }else  if(menuIndex=="Global_Crop_exposure_to_extremely_hightemperature"){
        this.radioGroupVisible_cv = false;
        this.radioGroupVisible_es = false;
      } else if(menuIndex=="Global_population_exposure_to_high_temperature"){
        this.radioGroupVisible_cv = false;
        this.radioGroupVisible_es = true;
        this.radioG_cc_prcptot_type = "value";
        this.selected_cascader = ["2000s_s0"];//设置时段&情景为默认值
      }else if(menuIndex=="global_gdp_exposure_to_drought"){
        this.selected_cascader = ["his_2000s"];//设置时段&情景为默认值


      }

      this.radioGroup_change();

    },




    /**
     * 动态更新要加载的地图图层数据
     * */
    radioGroup_change()
    {
      if(this.lastClicedMenuItem=="Global_population_exposure_to_rainstorm" || this.lastClicedMenuItem=="Global_population_exposure_to_high_temperature"){
        if(this.selected_cascader=="2000s_s0"){
          this.radioGroupVisible_cv = false;
        } else{
          this.radioGroupVisible_cv = true;
        }
      }

      //Raster Layer
      this.dynamicLodingWMSLayer();
    },


    removeRasterLayers(){
      let datas = ["1","2","3","4"];
      datas.forEach(item=>  {
        let layers = this.map.getLayers();
        let layer_lenght = layers.getLength();
        let rasterLayer = undefined;
        for(let i=0;i<layer_lenght;i++){
          const item_layer = layers.item(i);
          const layer_olTag = item_layer.olTag;
          if(layer_olTag && layer_olTag=="pesc"){
            rasterLayer = item_layer;
            break;
          }
        }
        if(rasterLayer){
          this.map.removeLayer(rasterLayer);
        }
      })
    },
    /**
     * 动态加载图层
     * */
    dynamicLodingWMSLayer(needUpdateLegends=true){
      if(this.defaultMapOverlay){
        this.defaultMapOverlay.setPosition(undefined);
      }

      console.log(" ");
      console.log("DynamicLodingWMSLayer::this.lastClicedMenuItem = ",this.lastClicedMenuItem);
      this.removeRasterLayers();
      const selected_cascader_value = this.selected_cascader[this.selected_cascader.length-1];
      let layerCode = "exp";
      if (this.lastClicedMenuItem=="Population"){
        layerCode += "_pop";
        //时段
        layerCode +="_"+selected_cascader_value;
        ////特征值
        if(selected_cascader_value=="2000s_s0"){
          layerCode +="_value";
        }else {
          layerCode +="_value"
        }
        //模式
        layerCode +="_sing";//模式
        //区域
        layerCode +="_global";
      }
      else if (this.lastClicedMenuItem=="Gross_domestic_production"){
        console.log("GenerateWMSAccessLayerCode::Start");
        layerCode += "_GDP";
        //时段
        layerCode +="_"+selected_cascader_value;
        ////特征值
        if(selected_cascader_value=="2000s_s0"){
          layerCode +="_value";
        }else {
          layerCode +="_value"
        }
        //模式
        layerCode +="_sing";//模式
        //区域
        layerCode +="_global";
      }
      else if (this.lastClicedMenuItem=="Global_crop_distribution") {
        console.log("GenerateWMSAccessLayerCode::Start");
        layerCode += "_" + this.radioG_cc_prcptot;
        //时段
        layerCode += "_" + selected_cascader_value;
        ////特征值 value = change
        layerCode += "_value";
        //模式
        if (this.radioG_cc_prcptot == "maize") {
          if (selected_cascader_value == "2000s_s0") {
            layerCode += "_sing";
          } else {
            layerCode += "_mme";
          }
        } else {
          layerCode += "_" + this.radioG_cc_prcptot_mm
        }

        //区域
        layerCode += "_global";
      }
      else if(this.lastClicedMenuItem=="Global_industrial_value_added"){
        layerCode += "_ind_value";
        //时段
        layerCode +="_"+selected_cascader_value;
        //特征值
        layerCode +="_value";
        //模式
        layerCode +="_sing";//模式
        //区域
        layerCode +="_global";
      }
      else if(this.lastClicedMenuItem=="Global_road_system"){
        layerCode += "_road";
        //时段
        if(selected_cascader_value=="2000s_s0"){
          layerCode +="_2010_s0";
        }else {
          layerCode +="_"+selected_cascader_value;
        }
        //特征值
        layerCode +="_value";
        //模式
        layerCode +="_sing";//模式
        //区域
        layerCode +="_global";
      }
      else if(this.lastClicedMenuItem=="Global_population_exposure_to_high_temperature"){
        // alert("NO DATA !");
        // return;

        layerCode += "_pop_ht";
        //时段
        layerCode +="_"+selected_cascader_value;
        //
        if(selected_cascader_value=="2000s_s0"){
          //特征值
          layerCode +="_value";
        }else {
          //特征值
          layerCode +="_";
          layerCode +=this.radioG_cc_prcptot_type;
        }
        //模式
        layerCode +="_";
        layerCode +=this.radioG_cc_prcptot_mm;//模式
        //区域
        layerCode +="_global";

      }
      else if(this.lastClicedMenuItem=="Global_population_exposure_to_rainstorm"){
        layerCode += "_pop_rain";
        //时段
        layerCode +="_"+selected_cascader_value;
        //
        if(selected_cascader_value=="2000s_s0"){
          //特征值
          layerCode +="_value";
        }else {
          //特征值
          layerCode +="_";
          layerCode +=this.radioG_cc_prcptot_type;
        }

        //模式
        layerCode +="_";
        layerCode +=this.radioG_cc_prcptot_mm;//模式
        //区域
        layerCode +="_global";
      }
      else if(this.lastClicedMenuItem=="Global_GDP_exposure_to_flood"){
        this.updateMapLengends(layerCode,undefined);
        alert("NO DATA !");
        return;
      }
      else if(this.lastClicedMenuItem=="Global_Crop_exposure_to_extremely_hightemperature"){
        layerCode += "_" + this.radioG_cc_prcptot+"_ht"
        //时段
        layerCode += "_" + selected_cascader_value;
        ////特征值 value = change
        layerCode += "_value";

        if(this.radioG_cc_prcptot=="maize"){
          if(this.selected_cascader=="2000s_s0"){
            layerCode += "_sing";
          }
          else{
            layerCode += "_mme";
          }

        }
        else {
          layerCode += "_mme";
        }
        //区域
        layerCode += "_global";
      }else if(this.lastClicedMenuItem=="global_gdp_exposure_to_drought"){
        console.log("global_gdp_exposure_to_drought &&  this.selected_cascader = ",this.selected_cascader);
        layerCode ="gdp_exposure_drought_";
        layerCode += this.selected_cascader[this.selected_cascader.length-1]+"_"+this.radioG_cc_prcptot;
      }



      //Read Workspace
      let wms_ws = this.lastClicedMenuItem;
      if(this.lastClicedMenuItem=="Global_crop_distribution"){
        wms_ws = "Global_"+this.radioG_cc_prcptot+"_distribution";
      }else if(this.lastClicedMenuItem=="Global_Crop_exposure_to_extremely_hightemperature"){
        wms_ws = "Global_"+this.radioG_cc_prcptot+"_exposure_to_extremely_high_temperature";
      }else if(this.lastClicedMenuItem=="Global_population_exposure_to_high_temperature"){
        wms_ws = "global_population_exposure_to_high_temperature";
      }else if(this.lastClicedMenuItem=="global_gdp_exposure_to_drought"){
        wms_ws = "gdp_drought_exposure";
      }

      wms_ws = wms_ws.toLowerCase();

      //Load WMS
      let tifflayer_accessurl = this.readGeoTiffAccessUrl(wms_ws);
      layerCode = layerCode.toLowerCase();
      this.selectedRasterMapSrouce = layerCode;


      let layerSytleColorGroups = undefined;
      // if(this.selectedMapLegendsStyle.length==0){
      //   this.$message.warning("Style Render File undefined !!!");
      // }else {
      //   let styleData= this.$olMapUtils.colorGroupReverse(this.selectedMapLegendsStyle);
      //   layerSytleColorGroups =this.$olMapUtils.parseSLDBody(this.$x2js,layerCode, styleData);
      // }
      if(needUpdateLegends){
        console.log("needUpdateLegends && 缓存模式");
        this.updateMapLengends(layerCode,wms_ws);
      }else {
        console.log("needUpdateLegends && 动态样式");
        let styleData= this.$olMapUtils.colorGroupReverse_NODATA_BLACK(this.selectedMapLegendsStyle);
        layerSytleColorGroups =this.$olMapUtils.parseSLDBodyWithType(this.$x2js,layerCode, styleData,"RAMP");
      }


      if(this.selectedRasterMapLayer!=undefined){
        this.map.removeLayer(this.selectedRasterMapLayer);
        this.selectedRasterMapLayer = undefined;
      }

      //console.log("LayerAccessURL =",wms_ws+":"+layerCode,"& layerSytleColorGroups = ",layerSytleColorGroups);
      this.selectedRasterMapLayer = this.$olMapUtils.addWMSLayer({
        defaultStyles:layerSytleColorGroups,
        layerName:layerCode,
        layerCode:layerCode,
        visible:true,geoServer:tifflayer_accessurl,zIndex:0,olTag:"pesc"});

      this.addTDM_LAYER_EVA_C();
      /**
       * 更新ocean layer 的styele
       * */
      this.updateOceanMapLayer();
      //
      this.updateMapLegendTitle();
    },


    //更新地图图例
    updateMapLegendTitle(){
      let current_layer_code = this.selectedRasterMapSrouce.replace(":","_").toUpperCase();
      let title = BSDConfigLegendTitle[current_layer_code];
      if(title==undefined){
        current_layer_code = current_layer_code.replace("GLOBAL","GOBAL").toUpperCase();
        title = BSDConfigLegendTitle[current_layer_code];
      }
      this.legendTitle =title;
    },


    /**
     * Annual && Winter && Summer 配置参数更新
     * */
    radioG_MapTime_updateConfig(){

      console.log("update radio group= ",this.lastClicedMenuItem);
      let selectedRadioGroupData =  Pesc_radioGroupData[this.lastClicedMenuItem];
      console.log("selectedRadioGroupData = ",selectedRadioGroupData," &length = ",selectedRadioGroupData.length);
      if(selectedRadioGroupData.length>0) {
        let defaultRadio = selectedRadioGroupData[0];
        this.radioG_cc_prcptot = defaultRadio.radio_code;
      }
      this.radioData = selectedRadioGroupData;
    },


    /**
     *
     **/
    readGeoTiffAccessUrl(workspace){
      workspace = workspace.toLowerCase();
      return this.geoserver_basic+workspace+"/wms";
    },

    /**
     * 级联菜单 2020年9月28日16:09:41
     * */
    cascader_changed(value){
      console.log(value);
    },

    /**
     * Resize Map Container
     * */
    mapSourceLayout(){
      if(this.selectedRasterMapSrouce==undefined){
        document.getElementById("IDLegend").style.bottom = "40px";
      } else {
        document.getElementById("IDLegend").style.bottom = "40px";
      }
    },

    updateSelectedActiveTag(sm){
      switch (sm) {
        case "Population":
          this.activeTab=0;
          break;
        case "Gross_domestic_production":
          this.activeTab=1;
          break;
        case "Global_crop_distribution":
          this.activeTab=2;
          break;
        case "Global_industrial_value_added":
          this.activeTab=3;
          break;
        case "Global_road_system":
          this.activeTab=4;
          break;
        case "Global_population_exposure_to_high_temperature":
          this.activeTab=5;
          break;
        case "Global_population_exposure_to_rainstorm":
          this.activeTab=6;
          break;
        case "global_gdp_exposure_to_drought":
          this.activeTab=7;
          break;
        case "Global_Crop_exposure_to_extremely_hightemperature":
          this.activeTab=8;
          break;
      }
    },

    /**
     * 根据路由路径打开默认的地图图层
     * */
    openDefaultMapSource(){
      // let routerPath = this.$route.path;
      // let pathAry = routerPath.split("\/");
      // let last_router_path = pathAry[pathAry.length-1];
      // if(last_router_path=="pesc")//气候的默认图层
      // {
      //   this.foldMenuClick({
      //     index:"Population",
      //     $attrs:{
      //       menuGroup:"cc_temprature"
      //     }
      //   })
      // }


      let sm = this.$route.query.sm
      if(sm==undefined){
        sm = "Population";
      }
      this.default_activemenu_cc = sm;

      this.foldMenuClick({
        index:sm,
        $attrs:{menuGroup:"cc_temprature"}
      })

      this.updateSelectedActiveTag(sm);

      //activeTab



    },


    legend_layoutupdate(data){
      let obj = document.getElementById("IDLegend");
      let obj_height = obj.style.height;
      obj.style.bottom = (0-parseInt(data))-50 +"px";
    },

    legend_layoutupdate_show(){
      let obj = document.getElementById("IDLegend");
      obj.style.bottom = "40px";

      if(this.legendModel==0){
        this.legendModel=1;
        document.getElementById("IDLegend").style.display = 'block';
      }else {
        this.legendModel = 0;
        document.getElementById("IDLegend").style.display = 'none';
      }

      if(this.legendModel==1){
        this.$refs.ref_mapLegend.updateHeight();
      }
    },


    /**
     * @author zhangchengguo
     * @description 导出地图文件
     * */
    doMapExport(){
      let _map = this.map;
      this.map.once('rendercomplete', function () {
        var mapCanvas = document.createElement('canvas');
        var size =_map.getSize();
        mapCanvas.width = size[0];
        mapCanvas.height = size[1];
        var mapContext = mapCanvas.getContext('2d');
        Array.prototype.forEach.call(
          document.querySelectorAll('.ol-layer canvas'),
          function (canvas) {
            if (canvas.width > 0) {
              var opacity = canvas.parentNode.style.opacity;
              mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
              var transform = canvas.style.transform;
              // Get the transform parameters from the style's transform matrix
              var matrix = transform
                .match(/^matrix\(([^\(]*)\)$/)[1]
                .split(',')
                .map(Number);
              // Apply the transform to the export map context
              CanvasRenderingContext2D.prototype.setTransform.apply(
                mapContext,
                matrix
              );
              mapContext.drawImage(canvas, 0, 0);
            }
          }
        );
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(mapCanvas.msToBlob(), 'map.png');
        } else {
          var link = document.getElementById('image-download');
          link.href = mapCanvas.toDataURL();
          link.click();
        }
      });
      _map.renderSync();
    },

    mapExport(){
      console.log("BSDMapRISK::mapExport");
      let _this = this;
      api_bnu_docDownloadTimes({path:this.selectedRasterMapSrouce.toLowerCase()}).then(res=>{
        let rData = res.data;
        console.log("rData = ",rData);
        _this.doMapExport();
      })
    },






    /**
     * @description 地图详情预览
     * */
    mapDeitalView(){
      console.log("mapDeitalView::radioG_cc_prcptot = ",this.radioG_cc_prcptot," & this.lastClicedMenuItem = ",this.lastClicedMenuItem);
      let raster_source =  this.selectedRasterMapSrouce.replace(":","_").toUpperCase();
      //window.open("https://cbcdn.cafewallet.cn/docfile/FileDownlaodTtest_20201127.docx","_blank");
      let selectedMenu = this.lastClicedMenuItem.toLowerCase();
      let file_url = AppConfig.minio_server+"/bun/population_economic/";
      if(selectedMenu=="population"){
        file_url = file_url +"01Population/";
      }else if(selectedMenu=="gross_domestic_production"){
        file_url = file_url +"02GrossdomesticProduction/";
      }else if(selectedMenu=="global_crop_distribution"){
        file_url = file_url +"03Globalcropdistribution/";
        if(this.radioG_cc_prcptot=="rice"){
          file_url = file_url +"01Rice/";
        }else if(this.radioG_cc_prcptot=="wheat"){
          file_url = file_url +"02Wheat/";
        }else if(this.radioG_cc_prcptot=="maize"){
          file_url = file_url +"03Maize/";
        }
      }else if(selectedMenu=="global_industrial_value_added"){
        file_url = file_url +"04Globalindustrialvalueadded/";
      }else if(selectedMenu=="global_road_system"){
        file_url = file_url +"05Globalroadsystem/";
      }else if(selectedMenu=="global_population_exposure_to_high_temperature"){
        file_url = file_url +"06Globalpopulationexposuretohightemperature/";
        //做一些特殊处理
        raster_source = raster_source.replace("0S","0s");
        raster_source = raster_source.replace("GLOBAL","Global");
      }else if(selectedMenu == "global_population_exposure_to_rainstorm"){
        file_url = file_url +"07Globalpopulationexposuretorainstorm/";
      }else if(selectedMenu =="global_gdp_exposure_to_drought"){
        this.$message.error("DATA FORMATE IS NOT CORRECT");
        return ;
      }else if(selectedMenu == "global_crop_exposure_to_extremely_hightemperature"){
        file_url = file_url +"09Globalcropexposuretoextremelyhightemperature/";
        if(this.radioG_cc_prcptot=="rice"){
          file_url = file_url +"01rice/";
        }else if(this.radioG_cc_prcptot=="wheat"){
          file_url = file_url +"02wheat/";
        }else if(this.radioG_cc_prcptot=="maize"){
          file_url = file_url +"03maize/";
        }
      }
      file_url = file_url + raster_source;
      file_url =file_url + ".docx";
      console.log("Download Map Description File = ",file_url);
      window.open(file_url,"_blank");
    },




    /**
     * 矢量英文注记
     * */
    addTDM_LAYER_EVA_C(){

      let  selectedLayer = undefined;
      const layers = this.map.getLayers();
      const layer_lenght = layers.getLength();

      for(let i=0;i<layer_lenght;i++){
        const item = layers.item(i);
        const item_name = item.name;
        //console.log("index = ",i," &layer = ",item,"&item_name = ",item_name);
        if(item_name!=undefined && item_name=="BSD:TDM_LAYER_EVA_C") {
          selectedLayer = item;
        }
      }

      if(selectedLayer==undefined){
        TDM_LAYER_EVA_C.setZIndex(500);
        this.map.addLayer(TDM_LAYER_EVA_C);
      }
      console.log("addTDM_LAYER_EVA_C::done");
    },



    /**
     * 查询地图点击查询值
     * */
    readMapPoint(evt){

      this.defaultMapOverlay.setPosition(undefined);
      //校验点是否有效
      let view = this.map.getView();
      let viewResolution = view.getResolution();
      let source =this.basicOceanLayer.getSource();
      let url = source.getFeatureInfoUrl(
        evt.coordinate,
        viewResolution,
        view.getProjection(),
        {'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 50});
      let _this = this;
      console.log("request url = ",url);
      this.axios.get(url).then((response)=>{
        console.log("checkQueryPointValid::response.data = ",response.data);
        const selectedFeatures =response.data.features;
        if(selectedFeatures.length==0){
          _this.readSelectedPointData(evt);
        }
      })
    },


    readSelectedPointData(evt){
      var view = this.map.getView();
      var viewResolution = view.getResolution();
      var source =this.selectedRasterMapLayer.getSource();
      var url = source.getFeatureInfoUrl(
        evt.coordinate,
        viewResolution,
        view.getProjection(),
        {'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 50});

      console.log("url = ",evt);
      this.axios.get(url).then((response)=>{
        console.log("response.data = ",response.data);
        const selectedFeatures =response.data.features;
        if(selectedFeatures.length>0) {
          const selectedFeature = selectedFeatures[0];
          const selectedFeature_properties = selectedFeature.properties;
          this.selectedRasterMapData = selectedFeature_properties.GRAY_INDEX;
          console.log("this.selectedRasterMapData = ",this.selectedRasterMapData);
          console.log(this.selectedRasterMapData+"");

          if(this.selectedRasterMapData==null){
            this.selectedRasterMapData = "NO DATA";
            this.defaultMapOverlay.setPosition(evt.coordinate);
            return;
          }


          //处理科学基数
          if(this.selectedRasterMapData!=undefined){
            console.log("处理科学基数");
            let raster_rate = this.getRasterValueRate();
            console.log("raster_rate = ",raster_rate);
            this.selectedRasterMapData = parseFloat(this.selectedRasterMapData)*this.getRasterValueRate();
          }


          if((this.selectedRasterMapData && this.selectedRasterMapData !=null) || parseFloat(this.selectedRasterMapData)!=0){
            if(parseFloat(this.selectedRasterMapData)<0){
              console.log("negitive value");
              let selectedRasterMapData_str = this.selectedRasterMapData+" ";
              if(selectedRasterMapData_str.indexOf("e+")>-1){
                console.log("negitive value && value is too small");
                this.selectedRasterMapData = "NO DATA";
              }
            }
            this.defaultMapOverlay.setPosition(evt.coordinate);
          } else {
            this.defaultMapOverlay.setPosition(undefined);
          }
        }
      })
    },

    getRasterValueRate(){
      let current_layer_code = this.selectedRasterMapSrouce.replace(":","_").toUpperCase();
      let rate = undefined;
      let title = BSDConfigLegendTitle[current_layer_code];
      if(title!=undefined){
        let title_seg = title.split("#");
        title_seg.forEach(item=>{
          if(item.indexOf("^")>-1){
            rate = item.split("^")[1]
          }
        })
      }
      let raster_value_rate = 1;
      if(rate!=undefined){
        for(let i=0;i<rate;i++){
          raster_value_rate = raster_value_rate*(0.1);
        }
      }
      return raster_value_rate;
    },


    initMapOverlay(){
      if(this.map && this.defaultMapOverlay==undefined){
        var container = document.getElementById('popup');
        var closer = document.getElementById('popup-closer');
        var overlay = new Overlay({
          element: container,
          autoPan: true,
          autoPanAnimation: {
            duration: 250,
          },
        });
        closer.onclick = function () {
          overlay.setPosition(undefined);
          closer.blur();
          return false;
        };
        this.map.addOverlay(overlay);
        this.defaultMapOverlay = overlay;
      }
    },

    /**
     * @author zhangchengguo at 2020年12月07日22:36:22
     * @description 更新海洋背景
     * */
    updateOceanMapLayer(){

      let selected_cascader_laster = this.selected_cascader[0];
      this.$olMapUtils.updateOceanMapLayer(this.map,selected_cascader_laster.toLowerCase());

      // console.log(" ");
      // console.log("-------");
      // let oceanLayerName = "BSD:ocean";
      // let mapLayerStyle = "ocean_baseline";
      //
      // let selected_cascader_laster = this.selected_cascader[0];
      // selected_cascader_laster = selected_cascader_laster.toLowerCase();
      // if(selected_cascader_laster=="2000s_s0"){
      //   mapLayerStyle = "ocean_baseline";
      // }else if(selected_cascader_laster=="2030s") {
      //   mapLayerStyle = "ocean_2030s";
      // }else if(selected_cascader_laster=="2050s") {
      //   mapLayerStyle = "ocean_2050s";
      // }
      // console.log("updateOceanMapLayer::selected_cascader_laster = ",selected_cascader_laster);
      // this.map.getLayers().forEach(function (layer) {
      //   const layer_name = layer.name;
      //   if(layer_name==oceanLayerName){
      //     layer.getSource().updateParams({'STYLES': mapLayerStyle});
      //   }
      // });
    }




  },

  mounted()
  {
    this.initLayout();
    this.initMap();
    this.selected_cascader =["2000s_s0"];

    this.basicOceanLayer = this.$olMapUtils.addWMSLayer({layerName:"bsd:ocean", layerCode:"bsd:ocean", visible:true,zIndex:9,});
    this.$olMapUtils.addWMSLayer({layerName:"bsd:country",layerCode:"bsd:country_project",visible:true,zIndex:10});
    // this.$olMapUtils.addWMSLayer({layerName:"BSD:countryborder",layerCode:"BSD:countryborder",visible:true,zIndex:11});
    this.$olMapUtils.addWMSLayer({layerCode:"bsd:geogrid_4326",zIndex:12});
    this.$olMapUtils.addWMSLayer({layerCode:"bsd:military_border",zIndex:13});
    this.$olMapUtils.addWMSLayer({layerCode:"bsd:undefine_country_border",zIndex:14});
    this.menuSpan=0;
    this.mapResize();


    let  _this = this;
    this.map.on('click', function (event) {
      var coordinate = event.coordinate;
      console.log("coordinate = ",coordinate);
      var _map = event.target;
      var pixel =_map.getPixelFromCoordinate(coordinate);
      console.log("pixel = ",pixel);

      if(_this.selectedRasterMapLayer){
        _this.readMapPoint(event);
      }

    });

    //
    //this.radioG_MapTime_updateConfig();
    //
    this.$watch('selectedRasterMapSrouce', function (newValue, oldValue) {//a是属性名，表示要监听的对象
      this.mapSourceLayout();
    });
    this.mapSourceLayout();
    //加载默认地图渲染图层
    this.openDefaultMapSource();

    //
    this.initMapOverlay();
    //
    //this.legend_layoutupdate_show();
    //
    this.loginUser = this.$appStorage.getUserMailbox();

    this.legendModel = 0;
    this.legend_layoutupdate_show();
    setTimeout(function (){
      if(_this.legendModel==1){
        _this.$refs.ref_mapLegend.updateHeight();
      }
    },50)

  }
}
</script>




<style scoped lang="scss">
@import "BSDMap";

</style>



// WEBPACK FOOTER //
// src/view/BSD/BSDMapPopulation.vue